module.exports = __webpack_public_path__ + "static/media/2.d4888b4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/2.jpg
// module id = 393
// module chunks = 0